import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';

class Cidades extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.CIDADES)
            return null;

        const countries = this.props.city.countries;

        if (!countries)
            return;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" },
            {
                "label": "País",
                "name": "country.id",
                "type": "select",
                "options": countries,
                "optionsPair": {
                    label: 'name',
                    value: 'id'
                }
            }
        ];

        const datatablesColumns = [
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "country.name", title: "País", render: $.datatable.renders.text() },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 160 },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 160 },
        ];

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/cities/select',
            createUrl: '/api/cities/insert',
            editUrl: '/api/cities/update/_id_',
            removeUrl: '/api/cities/delete/_id_',
        });

        const editorCreateTitle = 'Inserir cidade';
        const editorEditTitle = 'Editar cidade';
        const editorRemoveTitle = 'Remover cidade';
        const editorRemoveMessage = 'Deseja remover esta cidade?';

        const domClassName = 'cities-datatables';
        const title = 'Cidades';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
            />
        );
    }
}

export default Cidades;


// WEBPACK FOOTER //
// src/views/pages/Cidades.jsx